export const EntityPropertyLinkType = 'Property';
export const TaskLinkType = 'Task';